import axios from '@axios'

export default {
  // assembleia
  upload: formData => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/arquivos/uploads`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  ),
}
